/**
 * @file
 * Pluxee core script.
 */

(function ($, Drupal, once) {
    Drupal.behaviors.pluxee_core = {
        attach: function (context, settings) {

            // setup postMessage listener for iframes that send their content height.
            $(window).on("message", function(e){
                let data = e.originalEvent.data;
                $('iframe[src^="' + data.location + '"]').css({
                    'height': data.height + 'px'
                });
            });

            $(document).ready(function() {
                // trigger auto ifram height for euroland iframes.
                $('iframe[src*="euroland"]').EurolandIFrameAutoHeight();
            });
        }
    };
})(jQuery, Drupal, once);
